/******/ (() => {
class LinkedProducts extends HTMLElement {
  constructor() {
    super();
    this.onImageSwatchMouseEnterBound = this.onImageSwatchMouseEnter.bind(this);
    this.onImageSwatchMouseLeaveBound = this.onImageSwatchMouseLeave.bind(this);
  }

  connectedCallback() {
    this.imageSwatchLabel = this.querySelector('.linked-products--title-wrapper .linked-option-product-title');
    this.imageSwatches = this.querySelectorAll('.swatch-element.image-swatch');

    this.replaceSwatchesWithColorDots();
    this.setEventListeners();
    this.setActiveImageSwatchLabel();
  }

  replaceSwatchesWithColorDots() {
    this.imageSwatches.forEach(swatch => {
  const color = swatch.dataset.color;
  if (color) {
    // Nascondi il label con immagine
    const label = swatch.querySelector('label');
    if (label) {
      label.style.display = 'none';
    }

    // Evita duplicati
    if (!swatch.querySelector('.color-dot')) {
      const dot = document.createElement('span');
      dot.classList.add('color-dot');
      dot.style.display = 'inline-block';
      dot.style.width = '30px';
      dot.style.height = '30px';
      dot.style.borderRadius = '50%';
      dot.style.backgroundColor = color;
      dot.style.border = '1px solid #ccc';
      dot.style.transition = '0.2s';
      dot.style.cursor = 'pointer';

      // Recupera l'input per estrarre l'URL di redirect
      const input = swatch.querySelector('input');
      if (input) {
        const onclickAttr = input.getAttribute('onclick');
        let match = onclickAttr && onclickAttr.match(/window\.location\s*=\s*'([^']+)'/);
        if (match && match[1]) {
          const url = match[1];
          dot.addEventListener('click', () => {
            window.location.href = url;
          });
        }
      }

      swatch.appendChild(dot);
    }
  }
});

  }

  setActiveImageSwatchLabel() {
    const selectedImageSwatch = this.querySelector('.swatch-element.image-swatch.active');
    if (!selectedImageSwatch) return;
    this.updateSwatchLabel(selectedImageSwatch);
  }

  updateSwatchLabel = (swatch) => {
    if (!swatch) return;
    const label = swatch.getAttribute('data-value');
    if (!label || !this.imageSwatchLabel) return;
    this.imageSwatchLabel.textContent = label;
    this.imageSwatchLabel.classList.remove('fade-in-label');
    void this.imageSwatchLabel.offsetWidth;
    this.imageSwatchLabel.classList.add('fade-in-label');
  }

  setEventListeners() {
    if (!this.imageSwatches.length) return;

    this.imageSwatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', this.onImageSwatchMouseEnterBound);
      swatch.addEventListener('mouseleave', this.onImageSwatchMouseLeaveBound);
      swatch.addEventListener('click', () => this.setActiveSwatch(swatch));
    });
  }

  setActiveSwatch(swatch) {
    this.imageSwatches.forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');
    this.updateSwatchLabel(swatch);
  }

  onImageSwatchMouseEnter(event) {
    this.updateSwatchLabel(event.currentTarget);
  }

  onImageSwatchMouseLeave() {
    const activeImageSwatch = this.querySelector('.swatch-element.image-swatch.active');
    if (activeImageSwatch) {
      this.updateSwatchLabel(activeImageSwatch);
    } else {
      this.imageSwatchLabel.innerText = '';
    }
  }

  removeEventListeners() {
    this.imageSwatches.forEach(swatch => {
      swatch.removeEventListener('mouseenter', this.onImageSwatchMouseEnterBound);
      swatch.removeEventListener('mouseleave', this.onImageSwatchMouseLeaveBound);
    });
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

if (!window.customElements.get('linked-products')) {
  window.customElements.define('linked-products', LinkedProducts);
}
/******/ })();
